<template>
<div id="app">
  <v-app :dark="dark">
    <navigation :drawer="drawer" :clipped="clipped" @toggle="drawer = !drawer"></navigation>
    <v-toolbar fixed app :clipped-left="clipped">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{ $t($router.currentRoute.meta.title) }}</v-toolbar-title>
      <v-spacer />
      <LangBar v-if="AppSettings.displayLangBar()"></LangBar>
      <settings />
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <snackbar></snackbar>
  </v-app>
</div>
</template>

<script>
import Navigation from "@/components/navigation/Navigation"
import Settings from "@/components/Settings"
import Snackbar from "@/components/Snackbar"
import http from "@/plugins/http"
import LangBar from "@/components/LangBar";
import AppSettings from "@/plugins/Settings"
import Messenger from "./plugins/Messenger";
export default {
  components: {
    Navigation,
    Snackbar,
    Settings,
    LangBar,
  },
  data() {
    return {
      drawer: false,
      clipped: false,
      AppSettings
    }
  },
  computed: {
    dark() {
      return this.$store.getters.darkTheme
    }
  },
  created() {
    if(this.$websocket.isEnabled()){
      this.$websocket.registry('error',(data) => Messenger.emitError(data.data.message))
    }

    http.interceptors.response.use(undefined, (error) => {
      if (this.$store.getters.isAuthenticated && this.$store.state.tokenExpiration < Math.floor(Date.now() / 1000)) {
        if (this.$store.getters.keepLogged) {
          this.reLogin()
        } else {
          this.logout()
        }
      }
      throw error
    })
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch("load")
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("authLogout")
      this.$store.commit("setSnack", {
        message: this.$t("login.session-expiration"),
        color: "warning"
      })
      this.$router.push({
        name: "login"
      })
    },
    reLogin() {
      this.$store.dispatch("authRefresh")
        .then(() => {
          this.$router.go()
        }).catch(() => {
          this.logout()
        })
    }
  }
}
</script>

<style>
.v-btn--floating .v-icon {
  display: inline-flex !important;
}
</style>
